import Dataset from "./Dataset";

export default class Landmarks extends Dataset {
  type = "feature";
}
